import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

// import { useHistory } from "react-router-dom";
// const history = useHistory();

export default history


// WEBPACK FOOTER //
// ./src/history.js